var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('AppNavbar'),_c('AppNavbarMenu'),_c('router-view'),_c('Footer'),(_vm.showGoTopButton)?_c('button',{staticClass:"btn-go-top",on:{"click":_vm.scrollToTop}},[_c('i',{staticClass:"fa-solid fa-arrow-up"})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }